export const languageVersion = {
    // update this version anytime you add text to the language json files to force the browser to fetch the latest translations.
    version: 259
};
